import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest, makeRequest } from '@/base/MaRequestPooler.js'

/**
 * Returns aso report stats for date given.
 * @param trackId
 * @param countryCode
 * @param device
 * @param date
 * @returns {Promise<any>}
 */
export function getAsoReportForDay({ trackId, countryCode, date, device }) {
  const params = { date, device }

  return cacheRequest(`/app/${trackId}/aso-report/${countryCode}?${paramsToQuery(params)}`)
}

/**
 * Returns aso report stats for date range given.
 * @param trackId
 * @param countryCode
 * @param device optional
 * @param startDate
 * @param endDate
 * @returns {Promise<any>}
 */
export function getAsoReportStats({ trackId, countryCode, device, startDate, endDate }) {
  const params = { startDate, endDate, device }
  return cacheRequest(`/app/${trackId}/aso-report/${countryCode}/ranking-stats?${paramsToQuery(params)}`)
}

/**
 * Returns aso report stats for date range given.
 * @param trackId
 * @param countryCode
 * @param startDate
 * @param endDate
 * @param userKeywordGroupId optional
 * @returns {Promise<any>}
 */
export function getAsoReportTrackKeyword({ trackId, countryCode, startDate, endDate, userKeywordGroupId, device }) {
  const params = paramsToQuery({ startDate, endDate, userKeywordGroupId, device })
  return makeRequest(`/app/${trackId}/tracked-aso-report/${countryCode}/ranking-stats?${params}`)
}
